<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">{{routeName}}</a>
      <button class="navbar-toggler navbar-burger"
              type="button"
              @click="toggleSidebar"
              :aria-expanded="$sidebar.showSidebar"
              aria-label="Toggle navigation">
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
    </div></nav>
</template>
<script>
export default {
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    }
  },
  data() {
    return {
      activeNotifications: false
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      let returnString = '';
      switch (string) {
        case 'dashboard':
          returnString = 'Dashboard';
          break;
        case 'notifications':
          returnString = 'Notifications';
          break;
        case 'realtimepower':
          returnString = 'Real Time Power';
          break;
        case 'comparison':
          returnString = 'Comparison';
          break;
        case 'environment':
          returnString = 'Environment';
          break;
        case 'cost':
          returnString = 'Cost';
          break;
        case 'carbon_footprint':
          returnString = 'Carbon Footprint';
          break;
        case 'hvac':
          returnString = 'HVAC';
          break;
        case 'admin':
          returnString = 'Admin';
          break;
        case 'account':
          returnString = 'Admin/Account';
          break;
        case 'channeltypes':
          returnString = 'Admin/Channel Types';
          break;
        case 'rates':
          returnString = 'Admin/Rates';
          break;
        case 'edit_site':
          returnString = 'Admin/Edit Site';
          break;
        case 'edit_channel':
          returnString = 'Admin/ Edit Channel';
          break;
      }

      return returnString;
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    }
  }
};
</script>
<style>
</style>
